import { Menu, X } from 'lucide-react'
import { useState } from 'react'

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="fixed w-full bg-white/95 backdrop-blur-sm z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="text-3xl font-bold text-orange-500">ABS Solar.</div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#home"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              HOME
            </a>
            <a
              href="#about"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              ABOUT
            </a>
            <a
              href="#service"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              SERVICE
            </a>
            <a
              href="#project"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              PROJECT
            </a>
            <a
              href="#pages"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              PAGES
            </a>
            <a
              href="#contact"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              CONTACT
            </a>
            <button className="px-6 py-2.5 border-2 border-orange-500 text-orange-500 rounded-full font-medium hover:bg-orange-500 hover:text-white transition-all duration-300">
              GET A QUOTE
            </button>
          </div>

          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 pt-2 pb-4 space-y-3">
            <a
              href="#home"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              HOME
            </a>
            <a
              href="#about"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              ABOUT
            </a>
            <a
              href="#service"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              SERVICE
            </a>
            <a
              href="#project"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              PROJECT
            </a>
            <a
              href="#pages"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              PAGES
            </a>
            <a
              href="#contact"
              className="block py-2 text-gray-700 hover:text-orange-500 font-medium"
            >
              CONTACT
            </a>
            <button className="w-full px-6 py-2.5 border-2 border-orange-500 text-orange-500 rounded-full font-medium hover:bg-orange-500 hover:text-white transition-all">
              GET A QUOTE
            </button>
          </div>
        </div>
      )}
    </nav>
  )
}
